/* SKINLETTE custom interactions: reveal, accordions, before/after slider */
(function(){
  function reveal(){
    var els=document.querySelectorAll('.sk-reveal:not(.in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    },{threshold:0.12});
    els.forEach(function(e){io.observe(e);});
  }
  function accordions(){
    document.querySelectorAll('.sk-acc__head').forEach(function(btn){
      if(btn.dataset.bound) return; btn.dataset.bound='1';
      btn.addEventListener('click',function(){
        var acc=btn.closest('.sk-acc'); var body=acc.querySelector('.sk-acc__body');
        var open=acc.classList.toggle('open');
        body.style.maxHeight=open?body.scrollHeight+'px':'0px';
      });
    });
  }
  function beforeAfter(){
    document.querySelectorAll('.sk-ba').forEach(function(ba){
      if(ba.dataset.bound) return; ba.dataset.bound='1';
      var handle=ba.querySelector('.sk-ba__handle'); var after=ba.querySelector('.sk-after');
      if(!handle||!after) return; var drag=false;
      function move(x){ var r=ba.getBoundingClientRect(); var pct=((x-r.left)/r.width)*100; pct=Math.max(2,Math.min(98,pct)); after.style.clipPath='inset(0 0 0 '+pct+'%)'; handle.style.left=pct+'%'; }
      handle.addEventListener('mousedown',function(){drag=true;});
      window.addEventListener('mouseup',function(){drag=false;});
      window.addEventListener('mousemove',function(e){ if(drag) move(e.clientX); });
      ba.addEventListener('click',function(e){ move(e.clientX); });
      handle.addEventListener('touchmove',function(e){ move(e.touches[0].clientX); },{passive:true});
    });
  }
  function init(){ reveal(); accordions(); beforeAfter(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
